import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fetchBrands } from '@/lib/api';
import { BrandType } from '@/types/brand';
type ParamsType = {
  vehicleGroupIds?: string[];
  categoryIds?: string[];
  queryEnabled?: boolean;
};
const useBrands = t0 => {
  const $ = _c(14);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    vehicleGroupIds: t2,
    categoryIds: t3,
    queryEnabled: t4
  } = t1;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const vehicleGroupIds = t5;
  let t6;
  if ($[4] !== t3) {
    t6 = t3 === undefined ? [] : t3;
    $[4] = t3;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const categoryIds = t6;
  const queryEnabled = t4 === undefined ? true : t4;
  let t7;
  let t8;
  if ($[6] !== categoryIds || $[7] !== vehicleGroupIds) {
    t7 = ["brands", vehicleGroupIds, categoryIds];
    t8 = async () => fetchBrands({
      vehicleGroupIds,
      categoryIds
    });
    $[6] = categoryIds;
    $[7] = vehicleGroupIds;
    $[8] = t7;
    $[9] = t8;
  } else {
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] !== queryEnabled || $[11] !== t7 || $[12] !== t8) {
    t9 = {
      queryKey: t7,
      queryFn: t8,
      enabled: queryEnabled
    };
    $[10] = queryEnabled;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return useQuery(t9);
};
export default useBrands;